export { default as StarsMultipleSolidIcon } from './StarsMultipleSolidIcon';
